import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import { PageContent } from 'src/components/page';

export const ProductSection = styled.section`
  margin-bottom: ${layout.measurements.spacing250};
  padding: 0 ${layout.measurements.spacing050};
`;

export const ProductPadding = styled.div`
  height: 100%;
  padding: ${layout.measurements.spacing050};
  width: 200px;
`;

export const HeadlineContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  .category-title {
    margin: 0;
  }
`;

export const WrapOffers = styled.div`
  padding: 0 ${layout.measurements.spacing050};
`;

export const BodyGutter = styled.div`
  padding: 0 ${layout.measurements.spacing050};
`;

export const WrapBody = styled.div`
  margin: ${layout.measurements.spacing200} 0;
`;

export const WrapPageContainer = styled(PageContent)``;

export const Wrapper = styled.div`
  display: flex;
  flex: 1 1 100%;
  flex-direction: column;
  ${media.mediumUp`
    flex-direction: row;
  `}
`;

export const Sidebar = styled.div`
  min-width: 300px;
  max-width: 300px;
  ${media.smallOnly`
    max-width: 100%;
  `}
  padding: 0 10px;
`;

export const Main = styled.div``;

export const Header = styled.h1`
  font-size: 22px;
  margin: 20px 10px;
`;

export const ResultsHeader = styled.div`
  padding: 0px 10px;
`;
